import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NestedOption, PollOption} from '../../../_types/polls';
import {MatRadioButton} from '@angular/material/radio';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
    selector: 'app-nested-option',
    templateUrl: './nested-option.component.html',
    styleUrls: ['./nested-option.component.scss', '../poll-view.component.scss']
})
export class NestedOptionComponent {
    @Input() option!: PollOption;
    @Input() nestedOption!: NestedOption;
    @Input() preview: boolean = false;
    @Input() showResult: boolean = false;
    @Output() setResult: EventEmitter<boolean> = new EventEmitter<boolean>()

    @ViewChild('opt1', {static: false}) optionCheckbox!: MatCheckbox;
    @ViewChild('opt2', {static: false}) optionRadio!: MatRadioButton;


    public click(): void {
        if (this.optionCheckbox) {
            this.optionCheckbox._onInputClick();
        } else if (this.optionRadio) {
            this.optionRadio._inputElement.nativeElement.click();
        }
    }

    maxNestedOptionsCheck(): boolean {
        if (this.option?.max_nested_responses && this.option?.max_nested_responses > 0 && this.option?.nestedResults) {
            return (this.option?.nestedResults?.length >= this.option.max_nested_responses && !this.option?.nestedResults?.includes(this.nestedOption.id))
        } else {
            return false
        }
    }
}
